export const LABEL_QUARTER = 'Quarters';
export const LABEL_YEAR = 'Year';
